<nz-modal
  [nzVisible]="preview.previewModalVisible()"
  [nzTitle]="preview.previewEntry()?.fileName || ('mobile.filePreview.preview' | translate)"
  (nzOnCancel)="preview.closePreview()"
  [nzFooter]="null"
  [nzWidth]="980"
  [nzCancelText]="'mobile.filePreview.close_preview' | translate"
>
  <ng-container *nzModalContent>
    <div class="preview-content">
      <nz-spin [nzSpinning]="preview.previewLoading()" [nzDelay]="150">
        <div *ngIf="preview.previewError()" class="preview-error-wrap">
          <nz-empty
            [nzNotFoundContent]="(preview.previewError() || '') | translate"
            class="preview-empty"
          ></nz-empty>

          <div class="preview-actions preview-actions--error">
            <button class="desktop-button" nz-button nzType="default" (click)="retry()">
              <span nz-icon nzType="reload"></span>
              {{ 'common.retry' | translate }}
            </button>
            <button class="desktop-button" *ngIf="preview.previewUrl()" nz-button nzType="default" (click)="openExternal()">
              <span nz-icon nzType="export"></span>
              {{ 'mobile.filePreview.open_in_browser' | translate }}
            </button>
          </div>
        </div>

        <ng-container *ngIf="!preview.previewLoading() && !preview.previewError() && preview.previewEntry() as entry">
          <div *ngIf="preview.isPreviewImageEntry(entry)" class="preview-image-wrap">
            <div class="preview-image-stage" (wheel)="onImageWheel($event)">      <img
                class="preview-image"
                [src]="preview.previewUrl() || ''"
                [alt]="entry.fileName"
                [style.transform]="'scale(' + zoomScale() + ')'"
                [style.transform-origin]="zoomOrigin()"
              />
            </div>

            <div class="preview-actions">
              <button class="desktop-button" nz-button nzType="default" (click)="zoomOut()" [disabled]="!canZoomOut()">-</button>
              <button class="desktop-button" nz-button nzType="default" (click)="resetZoom()">100%</button>
              <button class="desktop-button" nz-button nzType="default" (click)="zoomIn()" [disabled]="!canZoomIn()">+</button>
              <span class="preview-zoom-indicator" aria-live="polite">{{ zoomPercentLabel() }}</span>
              <button class="desktop-button" nz-button nzType="default" (click)="openExternal()">
                <span nz-icon nzType="export"></span>
                {{ 'mobile.filePreview.open_in_browser' | translate }}
              </button>
              <button class="desktop-button" nz-button nzType="default" (click)="download()">
                <span nz-icon nzType="download"></span>
                {{ 'mobile.filePreview.download' | translate }}
              </button>
            </div>

            <p class="preview-shortcuts-hint" aria-hidden="true">Esc • + • - • 0 • Ctrl/Cmd + Wheel</p>
          </div>

          <div *ngIf="preview.isPreviewPdfEntry(entry)" class="preview-pdf-wrap">
            <iframe
              class="preview-pdf"
              [src]="preview.previewPdfUrl()"
              [title]="'mobile.filePreview.pdf_preview' | translate"
              (error)="preview.handlePdfRenderError()"
            ></iframe>

            <div class="preview-actions">
              <button class="desktop-button" nz-button nzType="default" (click)="openExternal()">
                <span nz-icon nzType="export"></span>
                {{ 'mobile.filePreview.open_in_browser' | translate }}
              </button>
              <button class="desktop-button" nz-button nzType="default" (click)="download()">
                <span nz-icon nzType="download"></span>
                {{ 'mobile.filePreview.download' | translate }}
              </button>
            </div>
          </div>
        </ng-container>    </nz-spin>
    </div>
  </ng-container>
</nz-modal>